import { Form, FormInstance } from 'antd';
import { useEffect } from 'react';
import { useCompanyFormContext } from '../CompaniesFormProvider';
import CustomTermInputText from './CustomTermInputText';

interface Props {
  form: FormInstance;
}

export default function CompanyCustomTermsForm({ form }: Props) {
  const { formValues } = useCompanyFormContext();
  useEffect(() => {
    if (formValues.companyTerms) {
      form.setFieldsValue(formValues.companyTerms);
    }
  }, [formValues.companyTerms]);

  return (
    <Form form={form} name="companyTerms" layout="vertical">
      <CustomTermInputText
        name="warrantyTerms"
        label="companies.customTerms.form.warrantyLabel"
        placeholder="companies.customTerms.form.warrantyPlaceholder"
      />

      <CustomTermInputText
        name="permanenceDeclaration"
        label="companies.customTerms.form.stayLabel"
        placeholder="companies.customTerms.form.stayPlaceholder"
      />

      <CustomTermInputText
        name="acquittanceTerms"
        label="companies.customTerms.form.dischargeLabel"
        placeholder="companies.customTerms.form.dischargePlaceholder"
      />

      <CustomTermInputText
        name="serviceOrderSigningStatement"
        label="companies.customTerms.form.signatureLabel"
        placeholder="companies.customTerms.form.signaturePlaceHolder"
      />

      <CustomTermInputText
        name="partsSuppliedTerms"
        label="companies.customTerms.form.partsSuppliedLabel"
        placeholder="companies.customTerms.form.partsSuppliedPlaceholder"
      />

      <CustomTermInputText
        name="lgpdTerms"
        label="companies.customTerms.form.rgpdLabel"
        placeholder="companies.customTerms.form.rgpdPlaceholder"
      />

      <CustomTermInputText
        name="responsabilityTerms"
        label="companies.customTerms.form.responsability"
        placeholder="companies.customTerms.form.responsabilityPlaceholder"
      />

      <CustomTermInputText
        name="plateSealCutTerms"
        label="companies.customTerms.form.plateSealCutTerms"
        placeholder="companies.customTerms.form.plateSealCutTermsPlaceholder"
      />
    </Form>
  );
}
